import api from './api';

const mediaService = {
  // Get all media files
  getMedia: (params = {}) => {
    return api.get('/api/media', { params });
  },

  // Get single media file
  getMediaFile: (id) => {
    return api.get(`/api/media/${id}`);
  },

  // Upload media file (returns raw axios response)
  uploadMedia: (file, folder = 'products', alt = '') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);
    if (alt) {
      formData.append('alt', alt);
    }

    return api.post('/api/admin/media/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Upload media and return data directly (convenience method)
  upload: async (file, folder = 'products', alt = '') => {
    try {
      const response = await mediaService.uploadMedia(file, folder, alt);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.message || 'Upload failed');
    } catch (err) {
      // Sanitize error message for user-friendly display
      let userMessage;

      // Network error
      if (!err.response) {
        userMessage = 'Cannot connect to server. Please check your internet connection and try again.';
      }
      // Server error (500-599)
      else if (err.response.status >= 500) {
        userMessage = 'Image upload service is temporarily unavailable. Please try again in a few moments or contact support if this persists.';
      }
      // File validation errors (400-499)
      else if (err.response.status === 413) {
        userMessage = `Image file is too large. Maximum size is 10MB.`;
      }
      else if (err.response.status === 415 || err.response.data?.error === 'INVALID_FILE_TYPE') {
        userMessage = 'Invalid file type. Please upload a JPEG, PNG, GIF, or WebP image.';
      }
      else if (err.response.status >= 400) {
        // Use backend message if it's a validation error, but sanitize it
        const backendMsg = err.response.data?.message || err.response.data?.error;
        if (backendMsg && backendMsg.length < 200 && !backendMsg.toLowerCase().includes('error')) {
          userMessage = backendMsg;
        } else {
          userMessage = 'Unable to upload image. Please try a different image or contact support.';
        }
      }
      // Unknown error
      else {
        userMessage = 'An unexpected error occurred while uploading the image. Please try again.';
      }

      // Create a new error with sanitized message
      const sanitizedError = new Error(userMessage);
      sanitizedError.originalError = err;
      throw sanitizedError;
    }
  },

  // Update media file
  updateMedia: (id, data) => {
    return api.put(`/api/media/${id}`, data);
  },

  // Delete media file
  deleteMedia: (id) => {
    return api.delete(`/api/media/${id}`);
  },

  // Bulk delete media files - not implemented yet in backend
  bulkDeleteMedia: (ids) => {
    return api.post('/api/media/bulk-delete', { ids });
  },

  // Get folders - not implemented yet in backend
  getFolders: () => {
    return api.get('/api/media/folders');
  },
};

export default mediaService;
